import { createSelector } from "@reduxjs/toolkit";
import { SLICE } from "../constants/slice";
import { initialState } from "./slice";
//
const selectDomain = (state) => state[SLICE.GLOBAL] || initialState;
/**
 * Getting hotel state to navbar component
 */
export const selectHotel = createSelector([selectDomain], (state) => state.hotel);
/**
 * Getting currency state to navbar component
 */
export const selectCurrency = createSelector([selectDomain], (state) => state.currency);
/**
 * Getting summary widget stay date state to navbar component
 */
export const selectStayDate = createSelector(
    [selectDomain],
    (state) => state.stayDate
  );